
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftBottom0 as ObiThreewayAnalogInleftBottom0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-bottom-0.js';
 
 
 

 
 export const ObiThreewayAnalogInleftBottom0 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-bottom-0',
   elementClass: ObiThreewayAnalogInleftBottom0Element,
   events: {
     
   }
  });
 
 